import React from 'react';
import { Routes, Route, Navigate, NavLink, useNavigate, useLocation } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Page from '../../../components/Page';
import Breadcrumb from '../../../components/Breadcrumb';
import Varietals from './varietals';
import Grapes from './grapes';
import GrapeEdit from './grapes/[gid]/edit';
import WineTypes from './wine-types';
import Accommodations from './accommodations';
import AccommodationsEdit from './accommodations/[aid]/edit';
import Categories from './categories';
import Holidays from './holidays';

const tabs = [
  { name: 'Varietals', path: 'varietals' },
  { name: 'Grapes', path: 'grapes' },
  { name: 'Wine Types', path: 'wine-types' },
  { name: 'Accommodations', path: 'accommodations' },
  { name: 'Categories', path: 'categories' },
  { name: 'Holidays', path: 'holidays' },
];

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

function DataManagementTabs() {
  const navigate = useNavigate();
  const location = useLocation();

  const getCurrentTab = () => {
    const pathParts = location.pathname.split('/');
    const tab = tabs.find((t) => pathParts.includes(t.path));
    return tab || tabs[0];
  };

  const onSelectChange = (e) => {
    const path = e.target.value;
    navigate(`/admin/data-management/${path}`);
  };

  return (
    <div className="mt-4 border-b border-gray-200">
      <div className="md:hidden">
        <label htmlFor="current-tab" className="sr-only">
          Select a tab
        </label>
        <select
          id="current-tab"
          name="current-tab"
          onChange={onSelectChange}
          className="block w-full rounded-md border-0 py-1.5 pl-3 pr-10 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary"
          value={getCurrentTab().path}
        >
          {tabs.map((tab) => (
            <option key={tab.name} value={tab.path}>
              {tab.name}
            </option>
          ))}
        </select>
      </div>
      <div className="hidden md:block">
        <nav className="-mb-px flex space-x-1 lg:space-x-6 xl:space-x-8">
          {tabs.map((tab) => (
            <NavLink
              key={tab.name}
              to={`/admin/data-management/${tab.path}`}
            >
              {({ isActive }) => (
                <div
                  className={classNames(
                    isActive
                      ? 'border-red-900 text-red-900'
                      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                    'whitespace-nowrap border-b-2 px-1 pb-4 text-sm font-medium'
                  )}
                >
                  {tab.name}
                </div>
              )}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}

export default function DataManagement() {
  const location = useLocation();

  // Check if we're on an edit page (accommodations/[aid]/edit)
  const isEditPage = location.pathname.includes('/edit');

  return (
    <Page title="Data Management">
      <Toaster
        toastOptions={{
          duration: 3000,
        }}
      />
      <div className="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">
        <nav className="flex" aria-label="Breadcrumb">
          <Breadcrumb elements={[{ name: 'Data Management' }]} />
        </nav>
      </div>

      {!isEditPage && <DataManagementTabs />}

      <div className="mt-6">
        <Routes>
          <Route path="/" element={<Navigate to="varietals" replace />} />
          <Route path="/varietals" element={<Varietals />} />
          <Route path="/grapes" element={<Grapes />} />
          <Route path="/grapes/:gid/edit" element={<GrapeEdit />} />
          <Route path="/wine-types" element={<WineTypes />} />
          <Route path="/accommodations" element={<Accommodations />} />
          <Route path="/accommodations/:aid/edit" element={<AccommodationsEdit />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/holidays" element={<Holidays />} />
        </Routes>
      </div>
    </Page>
  );
}
